// extracted by mini-css-extract-plugin
module.exports = {"SideDrawer":"SideDrawer_SideDrawer__3_fAC","Open":"SideDrawer_Open__3SRs3","Close":"SideDrawer_Close__k58jD","Logo":"SideDrawer_Logo__1TjRq","spin":"SideDrawer_spin__3ROHf"};